(function () {
  "use strict";
  if (window.__ymirWholesaleGuardLoaded) return;
  window.__ymirWholesaleGuardLoaded = true;

  var config = Object.assign({"endpoint": "https://ymir.buybetter.ng/api/v1/storefront/shopify/wholesale-rules", "storeDomain": "buybetterng.myshopify.com"}, window.YmirWholesaleGuardConfig || {});
  var rulesByVariantId = Object.create(null);
  var noRuleByVariantId = Object.create(null);
  var requestedKeys = Object.create(null);
  var productFormsSelector = 'form[action*="/cart/add"]';
  var checkoutSelector = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]';
  var buyControlSelector = 'button[type="submit"], button[name="add"], input[type="submit"], button.shopify-payment-button__button, .shopify-payment-button button';
  var quantitySelector = 'input[name="quantity"], input[data-quantity-input]';
  var guestActionSelector = 'add-to-cart, .card-information__button, .quick-view__summary, quick-view-drawer summary, form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"], a[href*="/cart/add"]';
  var guestCartNavSelector = 'a[href="/cart"], a[href^="/cart?"], #cart-icon-bubble, .header__icon--cart, .dock__item[href="/cart"]';
  var guestCartControlSelector = checkoutSelector + ', quantity-input, .quantity, .cart-item__quantity, .cart__checkout-button, .cart__dynamic-checkout-buttons, cart-remove-button, .cart-remove-button, a[href*="/cart/change"], button[name="checkout"]';
  var unavailableMessageSelector = "[data-ymir-wholesale-unavailable-message]";
  var guestGateSelector = "[data-ymir-guest-price-gate]";
  var guestPriceNodeSelector = '[data-product-price], [data-price], .price, .price-item, .product__price, .card-information .price, .product-card-wrapper .price, [class*="price"]';
  var cardTierSelector = "[data-ymir-wholesale-card-tiers]";
  var storefrontTimer = null;

  function uniq(values) {
    var seen = Object.create(null);
    return values.filter(function (value) {
      value = String(value || "").trim();
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    });
  }

  function money(value) {
    if (value === null || value === undefined || value === "") return "";
    var number = Number(value);
    if (!Number.isFinite(number)) return "";
    return "NGN " + number.toLocaleString("en-NG", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function variantKeys(value) {
    value = String(value || "").trim();
    if (!value) return [];
    var tail = value.split("/").pop();
    var keys = [value, tail];
    if (/^\d+$/.test(tail)) keys.push("gid://shopify/ProductVariant/" + tail);
    return uniq(keys);
  }

  function rememberRule(requestedId, rule) {
    variantKeys(requestedId).forEach(function (key) { delete noRuleByVariantId[key]; });
    variantKeys(requestedId).forEach(function (key) { rulesByVariantId[key] = rule; });
    variantKeys(rule.variant_gid).forEach(function (key) { rulesByVariantId[key] = rule; });
  }

  function rememberNoRule(requestedId) {
    variantKeys(requestedId).forEach(function (key) { noRuleByVariantId[key] = true; });
  }

  function findRule(variantId) {
    var keys = variantKeys(variantId);
    for (var index = 0; index < keys.length; index += 1) {
      if (rulesByVariantId[keys[index]]) return rulesByVariantId[keys[index]];
    }
    return null;
  }

  function hasLoadedNoRule(variantId) {
    var keys = variantKeys(variantId);
    for (var index = 0; index < keys.length; index += 1) {
      if (noRuleByVariantId[keys[index]]) return true;
    }
    return false;
  }

  function productPageVariantIds() {
    var ids = [];
    var metaVariants = (((window.ShopifyAnalytics || {}).meta || {}).product || {}).variants || [];
    metaVariants.forEach(function (variant) { if (variant && variant.id) ids.push(variant.id); });
    document.querySelectorAll(productFormsSelector + ' [name="id"]').forEach(function (field) {
      if (field.value) ids.push(field.value);
    });
    return uniq(ids);
  }

  function selectedVariantId(form) {
    var checked = form.querySelector('input[name="id"]:checked');
    if (checked && checked.value) return checked.value;
    var field = form.querySelector('[name="id"]');
    return field && field.value ? field.value : null;
  }

  function quantityInput(form) {
    return form.querySelector(quantitySelector);
  }

  function customerIsLoggedIn() {
    return !!(config.customer && (config.customer.loggedIn === true || config.customer.loggedIn === "true"));
  }

  function wholesaleLoginRequired() {
    return !!config.requireCustomerLogin && !customerIsLoggedIn();
  }

  function loginUrl() {
    var configured = String(config.loginUrl || "/account/login");
    var returnTo = window.location.pathname + window.location.search;
    return configured + (configured.indexOf("?") === -1 ? "?" : "&") + "return_url=" + encodeURIComponent(returnTo);
  }

  function registerUrl() {
    return String(config.registerUrl || "/account/register");
  }

  function installGuestGateStyles() {
    if (document.getElementById("ymir-guest-price-gate-styles")) return;
    var style = document.createElement("style");
    style.id = "ymir-guest-price-gate-styles";
    style.textContent = [
      "[data-ymir-guest-price-hidden='true'] { display:none !important; }",
      ".ymir-guest-price-gate { display:inline-flex !important; align-items:center; justify-content:center; min-height:44px; width:100%; max-width:360px; padding:0 18px; margin:10px 0 0; border:1px solid #f0d1dc; border-radius:8px; background:linear-gradient(135deg,#fff5fa 0%,#f7edf4 55%,#fff8df 100%); color:#a95d78 !important; text-decoration:none !important; font-size:14px; font-weight:700; line-height:1.2; letter-spacing:.04em; box-shadow:0 8px 18px rgba(169,93,120,.08); text-align:center; }",
      ".ymir-guest-price-gate:hover { border-color:#d99aae; background:linear-gradient(135deg,#fff0f7 0%,#f5e2eb 55%,#fff2bd 100%); color:#7f3f59 !important; }",
      ".ymir-guest-product-card { display:grid !important; gap:10px; max-width:420px; margin:14px 0; padding:14px 16px; border:1px solid #f0d1dc; border-radius:8px; background:#fff6fa; color:#3b2630; }",
      ".ymir-guest-product-card strong { font-size:15px; line-height:1.25; color:#7f3f59; }",
      ".ymir-guest-product-card span { font-size:13px; line-height:1.35; color:#6d3b4c; }",
      ".ymir-guest-product-card .ymir-guest-price-gate { margin:2px 0 0; max-width:none; }",
      ".ymir-guest-cart-card { display:grid !important; gap:10px; margin:24px 0; padding:18px 20px; border:1px solid #f0d1dc; border-radius:8px; background:linear-gradient(135deg,#fff5fa 0%,#fffaf0 100%); color:#3b2630; }",
      ".ymir-guest-cart-card strong { font-size:18px; line-height:1.25; color:#7f3f59; }",
      ".ymir-guest-cart-card span { font-size:14px; line-height:1.35; color:#6d3b4c; }",
      "body.ymir-guest-cart [data-ymir-guest-cart-hidden='true'] { display:none !important; }",
      "[data-ymir-guest-nav-cart-hidden='true'] { display:none !important; }",
      ".ymir-wholesale-card-item .price { display:none !important; }",
      ".ymir-wholesale-card-tiers { display:grid; grid-template-columns:repeat(auto-fit,minmax(min(100%,130px),1fr)); gap:8px; align-items:stretch; margin-top:10px; }",
      ".ymir-wholesale-card-tier { min-width:0; border:1px solid #f4e8ed; border-radius:8px; background:#fbf1f4; padding:8px 10px 7px; line-height:1.15; }",
      ".ymir-wholesale-card-tier-price { display:block; color:#111; font-size:13px; font-weight:700; letter-spacing:0; white-space:normal; }",
      ".ymir-wholesale-card-tier-price small { color:#6d3b4c; font-size:10px; font-weight:500; }",
      ".ymir-wholesale-card-tier-qty { display:block; margin-top:5px; color:#9b536a; font-size:10px; letter-spacing:0; white-space:nowrap; }",
      ".ymir-wholesale-card-tiers--sold-out .ymir-wholesale-card-tier { background:#f5f6f7; border-color:#e3e5e8; }",
      ".ymir-wholesale-card-tiers--sold-out .ymir-wholesale-card-tier-price { color:#626870; }",
      ".ymir-wholesale-card-tiers--sold-out .ymir-wholesale-card-tier-price small, .ymir-wholesale-card-tiers--sold-out .ymir-wholesale-card-tier-qty { color:#6b7280; }",
      "[data-ymir-wholesale-tier-card] { border:1px solid #f0d1dc; border-radius:8px; padding:12px; background:#fff6fa; display:grid; gap:8px; }",
      ".ymir-wholesale-product-tier-row { display:flex; justify-content:space-between; gap:10px; padding:8px 10px; border-radius:6px; background:#fbf1f4; color:#111; font-size:13px; letter-spacing:0; }",
      ".ymir-wholesale-product-tier-row.is-active { background:#a95d78; color:#fff; }",
      "@media (max-width: 749px) { .ymir-guest-price-gate { min-height:42px; padding:0 14px; font-size:13px; } }"
    ].join("\n");
    document.head.appendChild(style);
  }

  function containsMoney(text) {
    return /(?:NGN|₦|N\s*\d|\d[\d,]*(?:\.\d{2})?)/i.test(String(text || ""));
  }

  function isGuestPriceNode(node) {
    if (!node || !node.matches) return false;
    if (node.closest("[data-ymir-wholesale-message], [data-ymir-wholesale-cart-message], " + guestGateSelector)) return false;
    if (node.closest("header, nav, footer, .localization-form, [class*='currency'], [class*='money-format']")) return false;
    if (node.dataset.ymirGuestPriceHidden === "true") return false;
    var text = String(node.textContent || "");
    if (!containsMoney(text)) return false;
    var style = window.getComputedStyle ? window.getComputedStyle(node) : null;
    if (style && (style.display === "none" || style.visibility === "hidden")) return false;
    return true;
  }

  function guestGateHost(node) {
    return node.closest(".card-wrapper, .product-card-wrapper, .grid__item, .card-information, .product__info-container, .product, .shopify-section") || node.parentElement;
  }

  function ensureGuestGate(host, afterNode) {
    if (!host || host.querySelector(guestGateSelector)) return;
    var gate = document.createElement("a");
    gate.setAttribute("data-ymir-guest-price-gate", "true");
    gate.className = "ymir-guest-price-gate";
    gate.href = loginUrl();
    gate.textContent = "Login or Register to see price";
    if (afterNode && afterNode.parentNode) afterNode.parentNode.insertBefore(gate, afterNode.nextSibling);
    else host.appendChild(gate);
  }

  function hideGuestPriceNode(node) {
    if (!isGuestPriceNode(node)) return;
    node.dataset.ymirGuestPriceHidden = "true";
    var host = guestGateHost(node);
    ensureGuestGate(host, node);
  }

  function hideGuestBuyControls(root) {
    Array.prototype.slice.call((root || document).querySelectorAll(productFormsSelector)).forEach(function (form) {
      buyControls(form).forEach(function (control) {
        control.disabled = true;
        control.setAttribute("aria-disabled", "true");
        control.dataset.ymirGuestLocked = "true";
        control.style.display = "none";
      });
      Array.prototype.slice.call(form.querySelectorAll(quantitySelector)).forEach(function (input) {
        var wrapper = input.closest(".quantity") || input.closest("quantity-input") || input.closest("[class*='quantity']");
        (wrapper || input).style.display = "none";
      });
      var host = guestGateHost(form);
      if (host && host.querySelector(guestGateSelector)) return;
      var node = messageNode(form);
      if (!node.querySelector(guestGateSelector)) {
        node.className = "ymir-guest-product-card";
        node.textContent = "";
        var title = document.createElement("strong");
        title.textContent = "Wholesale prices are private";
        var detail = document.createElement("span");
        detail.textContent = "Login or create an account to see prices and checkout.";
        var gate = document.createElement("a");
        gate.setAttribute("data-ymir-guest-price-gate", "true");
        gate.className = "ymir-guest-price-gate";
        gate.href = loginUrl();
        gate.textContent = "Login or Register to see price";
        node.appendChild(title);
        node.appendChild(detail);
        node.appendChild(gate);
      }
    });
    Array.prototype.slice.call((root || document).querySelectorAll(guestActionSelector)).forEach(function (control) {
      if (control.closest("[data-ymir-guest-price-gate]") || control.closest(".ymir-guest-product-card")) return;
      control.dataset.ymirGuestLocked = "true";
      control.setAttribute("aria-disabled", "true");
      control.style.display = "none";
    });
    Array.prototype.slice.call((root || document).querySelectorAll(guestCartNavSelector)).forEach(function (control) {
      if (control.closest("[data-ymir-guest-price-gate]")) return;
      control.dataset.ymirGuestNavCartHidden = "true";
      control.setAttribute("aria-disabled", "true");
      control.style.display = "none";
    });
  }

  function markGuestCartHidden(node) {
    if (!node) return;
    node.dataset.ymirGuestCartHidden = "true";
    node.style.display = "none";
  }

  function guestCartMessageNode() {
    var node = document.querySelector("[data-ymir-guest-cart-card]");
    if (node) return node;
    node = document.createElement("div");
    node.setAttribute("data-ymir-guest-cart-card", "true");
    node.className = "ymir-guest-cart-card";
    var title = document.createElement("strong");
    title.textContent = "Login to view wholesale cart pricing";
    var detail = document.createElement("span");
    detail.textContent = "Your selected items are saved, but prices and checkout are only available after login or registration.";
    var gate = document.createElement("a");
    gate.setAttribute("data-ymir-guest-price-gate", "true");
    gate.className = "ymir-guest-price-gate";
    gate.href = loginUrl();
    gate.textContent = "Login or Register to see price";
    node.appendChild(title);
    node.appendChild(detail);
    node.appendChild(gate);
    var target = document.querySelector('form[action="/cart"], form[action^="/cart?"], main') || document.body;
    target.insertBefore(node, target.firstChild);
    return node;
  }

  function applyGuestCartGate() {
    installGuestGateStyles();
    document.body.classList.add("ymir-guest-cart");
    guestCartMessageNode();
    Array.prototype.slice.call(document.querySelectorAll(guestCartControlSelector)).forEach(markGuestCartHidden);
    Array.prototype.slice.call(document.querySelectorAll('[class*="price"], [class*="total"], [data-cart-item-final-price], [data-cart-item-line-price], .totals, .cart__ctas, .cart__footer, td, th, price-money, bdi')).forEach(function (node) {
      if (node.closest("[data-ymir-guest-cart-card]")) return;
      var text = String(node.textContent || "");
      var label = String(node.getAttribute("data-label") || node.className || "").toLowerCase();
      if (containsMoney(text) || label.indexOf("price") !== -1 || label.indexOf("total") !== -1 || label.indexOf("subtotal") !== -1 || /^(price|total|quantity)$/i.test(text.trim())) {
        markGuestCartHidden(node);
      }
    });
  }

  function applyGuestPriceGate(root) {
    installGuestGateStyles();
    if (window.location.pathname === "/cart") {
      applyGuestCartGate();
      return;
    }
    Array.prototype.slice.call((root || document).querySelectorAll(guestPriceNodeSelector)).forEach(hideGuestPriceNode);
    hideGuestBuyControls(root || document);
  }

  function scheduleStorefrontRules(delay) {
    window.clearTimeout(storefrontTimer);
    storefrontTimer = window.setTimeout(function () {
      if (wholesaleLoginRequired()) {
        applyGuestPriceGate();
        return;
      }
      loadRules(visibleVariantIds()).then(applyStorefrontRules);
    }, delay || 0);
  }

  function observeStorefrontChanges() {
    if (!window.MutationObserver) return;
    var target = document.querySelector("main") || document.body;
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.prototype.slice.call(mutation.addedNodes || []).some(function (node) {
          return node.nodeType === 1 && node.matches && (node.matches(guestPriceNodeSelector + ", " + productFormsSelector + ", " + guestActionSelector + ", " + guestCartNavSelector) || node.querySelector(guestPriceNodeSelector + ", " + productFormsSelector + ", " + guestActionSelector + ", " + guestCartNavSelector));
        });
      });
      if (relevant) scheduleStorefrontRules(50);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  function productGridContainers() {
    return Array.prototype.slice.call(document.querySelectorAll("#product-grid, .product-grid")).filter(function (grid) {
      return grid && grid.querySelector && grid.querySelector(".card-wrapper, .grid__item, [data-variant-id]");
    });
  }

  function collectionVariantIds() {
    var ids = [];
    productGridContainers().forEach(function (grid) {
      grid.querySelectorAll("[data-ymir-wholesale-variant-id], [data-variant-id]").forEach(function (node) {
        var value = node.getAttribute("data-ymir-wholesale-variant-id") || node.getAttribute("data-variant-id");
        if (value) ids.push(value);
      });
    });
    return uniq(ids);
  }

  function visibleVariantIds() {
    return uniq(productPageVariantIds().concat(collectionVariantIds()));
  }

  function messageNode(form) {
    var node = form.querySelector("[data-ymir-wholesale-message]");
    if (!node) {
      node = document.createElement("div");
      node.setAttribute("data-ymir-wholesale-message", "true");
      node.style.cssText = "margin:12px 0;padding:10px 12px;border:1px solid #111;border-radius:4px;color:#111;background:#fff;font-size:14px;line-height:1.35;";
      form.insertBefore(node, form.firstChild);
    }
    return node;
  }

  function buyControls(form) {
    return Array.prototype.slice.call(form.querySelectorAll(buyControlSelector));
  }

  function productShell(form) {
    return form.closest('.shopify-section') || form.closest('section') || form.closest('main');
  }

  function unavailableMessageNode(form) {
    var shell = productShell(form);
    var parent = shell && shell.parentNode ? shell.parentNode : document.body;
    var node = parent.querySelector(unavailableMessageSelector);
    if (!node) {
      node = document.createElement("div");
      node.setAttribute("data-ymir-wholesale-unavailable-message", "true");
      node.style.cssText = "margin:24px auto;padding:16px 18px;max-width:720px;border:1px solid #111;border-radius:4px;color:#111;background:#fff;font-size:16px;line-height:1.45;text-align:center;";
      if (shell && shell.parentNode) shell.parentNode.insertBefore(node, shell);
      else parent.insertBefore(node, parent.firstChild);
    }
    return node;
  }

  function hideProductShell(form, text) {
    var shell = productShell(form);
    var node = unavailableMessageNode(form);
    node.textContent = text;
    node.style.display = "block";
    if (shell) {
      shell.dataset.ymirWholesaleHidden = "true";
      shell.style.display = "none";
    }
  }

  function showProductShell(form) {
    var shell = productShell(form);
    if (shell && shell.dataset.ymirWholesaleHidden === "true") {
      shell.style.display = "";
      delete shell.dataset.ymirWholesaleHidden;
    }
    var node = document.querySelector(unavailableMessageSelector);
    if (node) {
      node.textContent = "";
      node.style.display = "none";
    }
  }

  function lockProductForm(form, text, hideProduct) {
    messageNode(form).textContent = text;
    buyControls(form).forEach(function (control) {
      control.disabled = true;
      control.setAttribute("aria-disabled", "true");
      control.dataset.ymirWholesaleLocked = "true";
      control.style.display = "none";
    });
    if (hideProduct) hideProductShell(form, text);
  }

  function unlockProductForm(form) {
    showProductShell(form);
    buyControls(form).forEach(function (control) {
      if (control.dataset.ymirWholesaleLocked !== "true") return;
      control.disabled = false;
      control.removeAttribute("aria-disabled");
      delete control.dataset.ymirWholesaleLocked;
      control.style.display = "";
    });
  }

  function ruleText(rule) {
    var parts = ["Minimum " + rule.minimum_quantity + " units for wholesale"];
    if (rule.base_price) parts.push("from " + money(rule.base_price));
    (rule.price_breaks || []).forEach(function (breakRow) {
      if (breakRow.minimum_quantity && breakRow.unit_price) {
        parts.push(breakRow.minimum_quantity + "+ at " + money(breakRow.unit_price));
      }
    });
    return parts.join(". ") + ".";
  }

  function tierRows(rule) {
    var tiers = Array.isArray(rule.price_tiers) ? rule.price_tiers.slice() : [];
    if (!tiers.length) {
      tiers.push({ minimum_quantity: rule.minimum_quantity, maximum_quantity: null, unit_price: rule.base_price });
      (rule.price_breaks || []).forEach(function (breakRow) {
        if (breakRow.minimum_quantity && breakRow.unit_price) {
          tiers.push({ minimum_quantity: breakRow.minimum_quantity, maximum_quantity: null, unit_price: breakRow.unit_price });
        }
      });
    }
    tiers.sort(function (left, right) { return Number(left.minimum_quantity || 0) - Number(right.minimum_quantity || 0); });
    tiers.forEach(function (tier, index) {
      var nextTier = tiers[index + 1];
      tier.maximum_quantity = nextTier ? Number(nextTier.minimum_quantity) - 1 : null;
    });
    return tiers;
  }

  function tierQuantityLabel(tier) {
    var min = Number(tier.minimum_quantity || 0);
    var max = Number(tier.maximum_quantity || 0);
    return max && max >= min ? min + " - " + max + " units" : min + "+ units";
  }

  function tierShortLabel(tier) {
    var min = Number(tier.minimum_quantity || 0);
    var max = Number(tier.maximum_quantity || 0);
    return max && max >= min ? "Buy " + min + "-" + max : "Buy " + min + "+";
  }

  function activeTier(rule, quantity) {
    var tiers = tierRows(rule);
    var selected = tiers[0] || null;
    tiers.forEach(function (tier) {
      if (Number(quantity || 0) >= Number(tier.minimum_quantity || 0)) selected = tier;
    });
    return selected;
  }

  function buildTierCard(form, rule) {
    var input = quantityInput(form);
    var quantity = Number(input && input.value ? input.value : rule.minimum_quantity);
    var current = activeTier(rule, quantity);
    var wrap = document.createElement("div");
    wrap.setAttribute("data-ymir-wholesale-tier-card", "true");
    var head = document.createElement("div");
    head.style.cssText = "display:flex;justify-content:space-between;gap:12px;align-items:baseline;font-size:12px;letter-spacing:0;";
    var label = document.createElement("strong");
    label.textContent = "Wholesale pricing";
    var minimum = document.createElement("span");
    minimum.textContent = "Min " + rule.minimum_quantity + " units";
    minimum.style.cssText = "color:#6d3b4c;";
    head.appendChild(label);
    head.appendChild(minimum);
    wrap.appendChild(head);
    tierRows(rule).forEach(function (tier) {
      var row = document.createElement("div");
      row.className = "ymir-wholesale-product-tier-row" + (current && Number(current.minimum_quantity) === Number(tier.minimum_quantity) ? " is-active" : "");
      var qty = document.createElement("span");
      qty.textContent = tierShortLabel(tier);
      var price = document.createElement("strong");
      price.textContent = money(tier.unit_price) + " each";
      row.appendChild(qty);
      row.appendChild(price);
      wrap.appendChild(row);
    });
    return wrap;
  }

  function renderTierRows(form, rule) {
    var node = messageNode(form);
    node.textContent = "";
    node.style.cssText = "margin:14px 0;padding:0;color:#111;background:#fff;font-size:14px;line-height:1.35;";
    node.appendChild(buildTierCard(form, rule));
  }

  function buildCardTierStrip(rule) {
    var wrap = document.createElement("div");
    wrap.setAttribute("data-ymir-wholesale-card-tiers", "true");
    wrap.className = "ymir-wholesale-card-tiers";
    tierRows(rule).slice(0, 2).forEach(function (tier) {
      var row = document.createElement("div");
      row.className = "ymir-wholesale-card-tier";
      var price = document.createElement("strong");
      price.className = "ymir-wholesale-card-tier-price";
      price.textContent = money(tier.unit_price) + " ";
      var unit = document.createElement("small");
      unit.textContent = "/ unit";
      price.appendChild(unit);
      var qty = document.createElement("span");
      qty.className = "ymir-wholesale-card-tier-qty";
      qty.textContent = tierQuantityLabel(tier);
      row.appendChild(price);
      row.appendChild(qty);
      wrap.appendChild(row);
    });
    return wrap;
  }

  function cardShellForVariantId(variantId) {
    var numericId = String(variantId || "").split("/").pop();
    var grids = productGridContainers();
    for (var index = 0; index < grids.length; index += 1) {
      var node = grids[index].querySelector('[data-ymir-wholesale-variant-id="' + numericId + '"], [data-variant-id="' + numericId + '"]');
      if (node) return node.closest(".card-wrapper") || node.closest(".grid__item") || node.closest("li");
    }
    return null;
  }

  function cardInfoForShell(shell) {
    return shell ? shell.querySelector(".card-information__wrapper") || shell.querySelector(".card-information") || shell : null;
  }

  function setCardHidden(shell, hidden) {
    if (!shell) return;
    var item = shell.closest(".grid__item") || shell;
    if (hidden) {
      item.dataset.ymirWholesaleHiddenCard = "true";
      item.style.display = "none";
      return;
    }
    if (item.dataset.ymirWholesaleHiddenCard === "true") {
      delete item.dataset.ymirWholesaleHiddenCard;
      item.style.display = "";
    }
  }

  function renderCollectionCardTiers() {
    var renderedShells = [];
    collectionVariantIds().forEach(function (variantId) {
      var shell = cardShellForVariantId(variantId);
      if (!shell || renderedShells.indexOf(shell) !== -1) return;
      var rule = findRule(variantId);
      if (!rule) {
        if (hasLoadedNoRule(variantId)) setCardHidden(shell, true);
        return;
      }
      setCardHidden(shell, false);
      var info = cardInfoForShell(shell);
      if (!info) return;
      var existing = info.querySelector(cardTierSelector);
      if (existing) existing.remove();
      var strip = buildCardTierStrip(rule);
      if (shell.getAttribute("data-ymir-wholesale-available") === "false") {
        strip.classList.add("ymir-wholesale-card-tiers--sold-out");
      }
      var price = info.querySelector(".price");
      if (price && price.parentNode === info) info.insertBefore(strip, price.nextSibling);
      else info.appendChild(strip);
      var item = shell.closest(".grid__item") || shell;
      item.classList.add("ymir-wholesale-card-item");
      renderedShells.push(shell);
    });
  }

  function candidatePriceNodes(form) {
    var shell = productShell(form) || document;
    return Array.prototype.slice.call(shell.querySelectorAll(guestPriceNodeSelector)).filter(function (node) {
      if (node.closest("[data-ymir-wholesale-message], [data-ymir-wholesale-tier-card]")) return false;
      return containsMoney(node.textContent);
    });
  }

  function updateVisiblePrice(form, rule) {
    candidatePriceNodes(form).forEach(function (node) {
      node.dataset.ymirWholesaleOriginalPrice = node.dataset.ymirWholesaleOriginalPrice || node.textContent;
      node.dataset.ymirWholesaleNativePriceHidden = "true";
      node.style.display = "none";
    });
  }

  function applyStorefrontRules() {
    applyProductFormRules();
    if (!wholesaleLoginRequired()) renderCollectionCardTiers();
  }

  function applyProductFormRules() {
    if (wholesaleLoginRequired()) {
      applyGuestPriceGate();
      return;
    }
    document.querySelectorAll(productFormsSelector).forEach(function (form) {
      var variantId = selectedVariantId(form);
      var rule = findRule(variantId);
      var input = quantityInput(form);
      if (!input) return;
      if (!rule) {
        if (variantId && hasLoadedNoRule(variantId)) {
          lockProductForm(form, "Wholesale pricing is not configured for this product/size yet.", true);
        } else if (variantId) {
          lockProductForm(form, "Loading wholesale pricing...");
        }
        return;
      }
      unlockProductForm(form);
      updateVisiblePrice(form, rule);
      renderTierRows(form, rule);
      input.min = String(rule.minimum_quantity);
      input.step = String(rule.quantity_increment || 1);
      if (!input.value || Number(input.value) < Number(rule.minimum_quantity)) {
        input.value = String(rule.minimum_quantity);
      }
    });
  }

  function loadRules(ids) {
    ids = uniq(ids).filter(function (id) { return !requestedKeys[id]; });
    if (!ids.length) return Promise.resolve();
    ids.forEach(function (id) { requestedKeys[id] = true; });
    var url = new URL(config.endpoint);
    url.searchParams.set("store_domain", config.storeDomain);
    url.searchParams.set("variant_ids", ids.join(","));
    return fetch(url.toString(), { credentials: "omit" })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (payload) {
        if (!payload || !payload.rules_by_variant_id) {
          ids.forEach(rememberNoRule);
          return;
        }
        Object.keys(payload.rules_by_variant_id).forEach(function (variantId) {
          rememberRule(variantId, payload.rules_by_variant_id[variantId]);
        });
        ids.forEach(function (id) {
          if (!findRule(id)) rememberNoRule(id);
        });
      })
      .catch(function () {
        ids.forEach(rememberNoRule);
        return null;
      });
  }

  function blockProductSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches(productFormsSelector)) return;
    if (form.dataset.ymirWholesaleBypass === "true") return;
    if (wholesaleLoginRequired()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      applyGuestPriceGate();
      window.location.href = loginUrl();
      return;
    }
    var variantId = selectedVariantId(form);
    var input = quantityInput(form);
    var quantity = Number(input && input.value ? input.value : 1);
    var rule = findRule(variantId);
    if (rule && quantity < Number(rule.minimum_quantity)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      messageNode(form).textContent = "This product/size has a wholesale minimum of " + rule.minimum_quantity + " units.";
      return;
    }
    if (!rule && variantId && hasLoadedNoRule(variantId)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      lockProductForm(form, "Wholesale pricing is not configured for this product/size yet.", true);
      return;
    }
    if (!rule && variantId) {
      event.preventDefault();
      event.stopImmediatePropagation();
      loadRules([variantId]).then(function () {
        applyStorefrontRules();
        var loadedRule = findRule(variantId);
        if (!loadedRule) {
          lockProductForm(form, "Wholesale pricing is not configured for this product/size yet.", true);
          return;
        }
        var loadedQuantity = Number(input && input.value ? input.value : 1);
        if (loadedRule && loadedQuantity < Number(loadedRule.minimum_quantity)) {
          messageNode(form).textContent = "This product/size has a wholesale minimum of " + loadedRule.minimum_quantity + " units.";
          return;
        }
        form.dataset.ymirWholesaleBypass = "true";
        if (form.requestSubmit) form.requestSubmit();
        else HTMLFormElement.prototype.submit.call(form);
        form.dataset.ymirWholesaleBypass = "false";
      });
    }
  }

  function blockGuestActionClick(event) {
    if (!wholesaleLoginRequired()) return;
    var trigger = event.target && event.target.closest && event.target.closest(guestActionSelector + ", " + guestCartNavSelector);
    if (!trigger || trigger.closest(guestGateSelector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    applyGuestPriceGate();
  }

  function cartVariantIds(cart) {
    return uniq((cart.items || []).map(function (item) { return item.variant_id; }));
  }

  function cartViolations(cart) {
    if (wholesaleLoginRequired()) {
      return [{ item: { product_title: "Wholesale checkout" }, loginRequired: true }];
    }
    return (cart.items || []).map(function (item) {
      var rule = findRule(item.variant_id);
      if (!rule && hasLoadedNoRule(item.variant_id)) {
        return { item: item, rule: null, missingRule: true };
      }
      if (rule && Number(item.quantity) < Number(rule.minimum_quantity)) {
        return { item: item, rule: rule };
      }
      return null;
    }).filter(Boolean);
  }

  function showCartViolations(violations) {
    var node = document.querySelector("[data-ymir-wholesale-cart-message]");
    if (!node) {
      node = document.createElement("div");
      node.setAttribute("data-ymir-wholesale-cart-message", "true");
      node.style.cssText = "margin:16px 0;padding:12px 14px;border:1px solid #111;border-radius:4px;color:#111;background:#fff;font-size:14px;line-height:1.35;";
      var cartForm = document.querySelector('form[action="/cart"], form[action^="/cart?"]') || document.querySelector("main") || document.body;
      cartForm.insertBefore(node, cartForm.firstChild);
    }
    if (!violations.length) {
      node.textContent = "";
      node.style.display = "none";
      return;
    }
    node.style.display = "block";
    node.textContent = violations.map(function (violation) {
      if (violation.loginRequired) {
        return "Login or register to checkout wholesale.";
      }
      if (violation.missingRule) {
        return (violation.item.product_title || violation.item.title || "This product") + " is not available for wholesale checkout.";
      }
      return (violation.item.product_title || violation.item.title || "This product") + " requires at least " + violation.rule.minimum_quantity + " units for wholesale.";
    }).join(" ");
  }

  function validateCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.json() : { items: [] }; })
      .then(function (cart) {
        return loadRules(cartVariantIds(cart)).then(function () {
          var violations = cartViolations(cart);
          showCartViolations(violations);
          return violations;
        });
      });
  }

  function blockCheckoutClick(event) {
    var trigger = event.target && event.target.closest && event.target.closest(checkoutSelector);
    if (!trigger) return;
    if (wholesaleLoginRequired()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      applyGuestPriceGate();
      window.location.href = loginUrl();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    validateCart().then(function (violations) {
      if (violations.length) return;
      window.location.href = "/checkout";
    });
  }

  function boot() {
    observeStorefrontChanges();
    if (wholesaleLoginRequired()) {
      applyGuestPriceGate();
      if (window.location.pathname === "/cart") validateCart();
      return;
    }
    document.querySelectorAll(productFormsSelector).forEach(function (form) {
      if (selectedVariantId(form) && quantityInput(form)) {
        lockProductForm(form, "Loading wholesale pricing...");
      }
    });
    installGuestGateStyles();
    loadRules(visibleVariantIds()).then(applyStorefrontRules);
    if (window.location.pathname === "/cart") validateCart();
  }

  document.addEventListener("submit", blockProductSubmit, true);
  document.addEventListener("click", blockGuestActionClick, true);
  document.addEventListener("click", blockCheckoutClick, true);
  document.addEventListener("change", function () {
    scheduleStorefrontRules(0);
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
